import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'y42-context-menu-text-color',
  styleUrls: ['context-menu-text-color.component.scss'],
  templateUrl: './context-menu-text-color.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContextMenuTextColorComponent {
  @Input()
  textColor?: string;

  @Output()
  textColorChanged = new EventEmitter<string>();

  readonly defaultTextColor = '#000';
}
